<template>
    <!-- SearchItem.vue -->
    <component
        :is="itemComponent"
        :item="item"
        v-bind="$attrs"
    ></component>
</template>

<script>
    import * as itemTypes from './items/item-types'
    // Components
    import BaseSearchItem from './items/BaseSearchItem'
    import CancellationSearchItem from './items/CancellationSearchItem'
    import ContactSearchItem from './items/ContactSearchItem'
    import ContractSearchItem from './items/ContractSearchItem'
    import CustomerSearchItem from './items/CustomerSearchItem'
    import InvoiceSearchItem from './items/InvoiceSearchItem'
    import ServiceNumberSearchItem from './items/ServiceNumberSearchItem'
    import ProductInventorySearchItem from './items/ProductInventorySearchItem'
    import StaffMemberSearchItem from './items/StaffMemberSearchItem'

    export default {
        name: 'SearchItem',
        components: {
            BaseSearchItem,
            CancellationSearchItem,
            ContactSearchItem,
            ContractSearchItem,
            CustomerSearchItem,
            InvoiceSearchItem,
            ServiceNumberSearchItem,
            StaffMemberSearchItem,
            ProductInventorySearchItem
        },
        props: {
            /**
             * The search result item i.e. {id: number, title: string, description: string}
             */
            item: {
                type: Object,
                required: true
            }
        },
        computed: {
            itemComponent () {
                const {type} = this.item

                switch (type) {
                    case itemTypes.CANCELLATION:
                        return CancellationSearchItem
                    case itemTypes.CONTACT:
                        return ContactSearchItem
                    case itemTypes.CONTRACT:
                        return ContractSearchItem
                    case itemTypes.CUSTOMER:
                        return CustomerSearchItem
                    case itemTypes.SERVICE_NUMBER:
                        return ServiceNumberSearchItem
                    case itemTypes.SERVICE_INVOICE:
                    case itemTypes.TRAFFIC_INVOICE:
                        return InvoiceSearchItem
                    case itemTypes.STAFF_MEMBER:
                        return StaffMemberSearchItem
                    case itemTypes.PRODUCT_INVENTORY:
                        return ProductInventorySearchItem
                    default:
                        return BaseSearchItem
                }
            }
        }
    }
</script>
